import { useState } from "react";
import { Camera, Loader2, Upload, X } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, fileUrl } from "@/lib/api";

export const MediaPreview = ({ f, className = "" }) => {
  const t = (f.content_type || "").split("/")[0];
  if (t === "image") return <img src={fileUrl(f.id)} alt={f.original_filename} className={`h-full w-full object-cover ${className}`} />;
  if (t === "audio") return <audio controls src={fileUrl(f.id)} className="w-full" />;
  if (t === "video") return <video controls src={fileUrl(f.id)} className={`w-full ${className}`} />;
  return <span className="text-xs text-slate-400">{f.original_filename}</span>;
};

export const FileUploader = ({ label, accept, files, onChange, testid, camera }) => {
  const [busy, setBusy] = useState(false);
  const onPick = async (e) => {
    const list = Array.from(e.target.files || []);
    e.target.value = "";
    if (!list.length) return;
    setBusy(true);
    const added = [];
    for (const file of list) {
      const fd = new FormData();
      fd.append("file", file);
      try {
        const { data } = await api.post("/uploads", fd);
        added.push(data);
      } catch (err) {
        toast.error(`${file.name}: ${errMsg(err)}`);
      }
    }
    setBusy(false);
    if (added.length) onChange([...files, ...added]);
  };
  return (
    <div data-testid={testid}>
      {label && <span className="field-label">{label}</span>}
      <label className={`flex cursor-pointer items-center justify-center gap-2 border border-dashed border-slate-600 bg-black/30 px-4 py-5 text-sm text-slate-300 transition-colors hover:border-red-500 hover:text-white ${busy ? "pointer-events-none opacity-60" : ""}`}>
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4 text-red-500" />}
        {busy ? "Enviando..." : "Clique para enviar arquivos"}
        <input type="file" accept={accept} multiple className="hidden" onChange={onPick} data-testid={`${testid}-input`} />
      </label>
      {camera && (
        <label className={`mt-2 flex cursor-pointer items-center justify-center gap-2 border border-slate-700 bg-black/30 px-4 py-3 text-sm text-slate-300 transition-colors hover:border-red-500 hover:text-white md:hidden ${busy ? "pointer-events-none opacity-60" : ""}`}>
          <Camera className="h-4 w-4 text-red-500" /> Usar a câmera
          <input type="file" accept={accept} capture="environment" className="hidden" onChange={onPick} data-testid={`${testid}-camera`} />
        </label>
      )}
      {files.length > 0 && (
        <div className="mt-3 grid grid-cols-2 gap-2 sm:grid-cols-3">
          {files.map((f) => (
            <div key={f.id} className="relative flex h-28 items-center justify-center overflow-hidden border border-slate-700 bg-black/40 p-1">
              <MediaPreview f={f} />
              <button type="button" onClick={() => onChange(files.filter((x) => x.id !== f.id))} data-testid={`${testid}-remove-${f.id}`}
                className="absolute right-1 top-1 bg-black/80 p-1 text-white hover:text-red-400" aria-label="Remover">
                <X className="h-3 w-3" />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
